import * as React from 'react';

const ChatSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={48} height={48} {...props}>
        <g
            id="chat_svg__Chat"
            stroke="#1D0A32"
            strokeWidth={2}
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <g id="chat_svg__globe-2" transform="translate(9 27)">
                <path
                    d="M11.287 17.332c2.16.459 4.22.668 6.713.668 9.941 0 18-4.03 18-9s-8.059-9-18-9S0 4.03 0 9c0 2.327 1.968 4.402 4.867 6"
                    id="chat_svg__Path"
                />
                <path id="chat_svg__Stroke-9" d="M8.32 9H28" />
                <path
                    d="M11.287 17.332C9.655 18.165 5.371 20 0 20c2.212-1.853 3.8-3.545 4.867-5"
                    id="chat_svg__Stroke-13"
                />
            </g>
            <g id="chat_svg__globe-1" transform="translate(1 1)">
                <path
                    d="M35 19.229c1.544.8 4.543 2.771 11 2.771a28.456 28.456 0 01-5.77-6.572"
                    id="chat_svg__Stroke-11"
                />
                <path id="chat_svg__Stroke-5" d="M10.001 8.001h22" />
                <path id="chat_svg__Stroke-7" d="M10.001 14.001h16" />
                <path
                    d="M34.94 19.228C31.232 20.953 26.35 22 21 22 9.402 22 0 17.076 0 11 0 4.925 9.402 0 21 0c11.599 0 21 4.925 21 11 0 1.576-.632 3.074-1.77 4.428"
                    id="chat_svg__Stroke-15"
                />
            </g>
        </g>
    </svg>
);

ChatSvg.displayName = 'ChatSvg';
export default ChatSvg;
